import { render } from "./S355487.vue?vue&type=template&id=1acc0316"
const script = {}
script.render = render

export default script